import type { ReactElement } from 'react';
import { Link } from 'react-router';

import { CardFrame, QueryBody } from '@/components/ui/card-frame';
import { actorLabel, formatWhen } from '@/features/traceability/event-presentation';

import { useRecentActivity } from '../use-dashboard';

// Actividad reciente (so=430, spec §3.6; mockup 01): últimos eventos de la bitácora
// inalterable, en el mismo lenguaje que Trazabilidad. Es de la empresa activa, salvo para
// un usuario de todas las empresas (la bitácora le muestra todas, como en Trazabilidad):
// el encabezado lo dice.

interface Props {
  companyId: string;
  crossCompany?: boolean;
}

export function ActivityCard({ companyId, crossCompany = false }: Props): ReactElement {
  const query = useRecentActivity({ companyId, enabled: true });
  return (
    <CardFrame
      title="Actividad reciente"
      count={crossCompany ? 'bitácora de todas las empresas' : 'bitácora inalterable'}
    >
      <QueryBody
        query={query}
        rows={4}
        isEmpty={(rows) => rows.length === 0}
        emptyText="Sin actividad registrada."
      >
        {(rows) => (
          <ol className="cb tl activity">
            {rows.map((row) => {
              const when = formatWhen(row.occurredAt);
              return (
                <li key={row.id} className="ev past">
                  <div className="t">
                    {row.actionLabel}
                    {row.targetCode && (
                      <>
                        {' · '}
                        <span className="code">{row.targetCode}</span>
                      </>
                    )}
                  </div>
                  <div className="w">
                    <b>{actorLabel(row)}</b> · {when.date} {when.time}
                  </div>
                </li>
              );
            })}
          </ol>
        )}
      </QueryBody>
      <div className="dash-foot">
        <Link to="/configuracion/trazabilidad" className="btn ghost sm">
          Ver trazabilidad
        </Link>
      </div>
    </CardFrame>
  );
}
